<template>
    <div class="box padding has-background-light">
        <loading :active.sync="isBusy"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <Nav style="margin-bottom: 20px;" />
        <div class="columns">
            <div class="column">
                <h4>Jobsite Drive Setup</h4>
                <b-field label="Jobsite">
                    <b-select placeholder="select jobsite" expanded v-model="newWorkunit.jobsiteId" @input="loadWorkUnitsByJobSite()">
                        <option v-for="item in jobsite" :value="item" :key="item.id">{{ item.nameJobsite }}</option>
                    </b-select>
                </b-field>
                <b-field label="Drive Selection" v-if="isEdit">
                    <b-select placeholder="select Drive" expanded v-model="newWorkunit">
                        <option v-for="item in workunits" :value="item" :key="item.id">{{ item.nameWorkunit }}</option>
                    </b-select>
                </b-field>

                <div class="columns">
                    <div class="column">
                        <b-field label="Jobsite Drive Name">
                            <b-input type="text"
                                placeholder="Drive Name"
                                maxlength="30"
                                v-model="newWorkunit.nameWorkunit"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Jobsite Drive Number">
                            <b-input type="number"
                                placeholder="Drive Number"
                                maxlength="30"
                                min="0"
                                v-model="newWorkunit.drive_number"></b-input>
                        </b-field>
                    </div>
                </div>
                
                
                <!--<b-field label="Drive execution order">
                    <b-input type="int" value="455-147-154" maxlength="11" v-model="newWorkunit.numberOrder"></b-input>
                </b-field>-->

                <b-field label="Upload kmz/kml" style="margin-bottom: 8px;">
                    <section>
                        <b-field>
                            <b-upload v-model="newWorkunit.pathKMZ" multiple :accept="extensionAccepted" drag-drop>
                                <div class="content has-text-centered">
                                    <p>
                                        <b-icon icon="upload" size="is-large"></b-icon>
                                    </p>
                                    <p>Drop your files here or click to upload</p>
                                </div>
                            </b-upload>
                        </b-field>
                        <div :class="{'tags' : newWorkunit.pathKMZ}">
                            <span v-for="(file, index) in newWorkunit.pathKMZ"
                                  :key="index"
                                  class="tag is-primary">
                                {{file.name}}
                                <button class="delete is-small"
                                        type="button"
                                        @click="deleteDropFile(index)"></button>
                            </span>
                        </div>
                        <p :class="{'original-name' : newWorkunit.originalNameKmz}" v-show="isEdit">{{ newWorkunit.originalNameKmz }}</p>
                    </section>
                </b-field>
                
                <div class="columns">
                    <div class="column">
                        <h6>Drive Internal Diameter</h6>
                        <b-field>
                            <b-input expanded placeholder="0.00" maxlength="30" v-model="newWorkunit.diameter"></b-input>
                            <p class="control">
                                <span class="button is-static">Meters</span>
                            </p>
                        </b-field>
                    </div>
                    <div class="column">
                        <h6>Drive Length</h6>
                        <b-field>
                            <b-input expanded placeholder="0.00" maxlength="30" v-model="newWorkunit.discLenght"></b-input>
                            <p class="control">
                                <span class="button is-static">Meters</span>
                            </p>
                        </b-field>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <b-field>
                            <b-checkbox size="is-medium" v-model="newWorkunit.inversion">Inversion</b-checkbox>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field>
                            <b-checkbox size="is-medium" v-model="newWorkunit.force_end_drive">Force la fin du drive</b-checkbox>
                        </b-field>
                    </div>
                </div>

                
                <b-field label="Comments">
                    <b-input maxlength="200" type="textarea" v-model="newWorkunit.comments"></b-input>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'CreateWorkunits',
        props: {
            isEdit: Boolean
        },
        components: {
            Loading
        },
        data() {
            return {
                jobsiteSelected: {},
                isBusy: false,
                workunits: [],
                geojson: [],
                jobsite: [],
                extensionAccepted:'.kmz,.kml',
                newWorkunit: {
                    id: 0,
                    jobsiteId: [],
                    nameWorkunit: '',
                    drive_number: 0,
                    pathKMZ: [],
                    pathGeojson: '',
                    diameter: '',
                    discLenght: '',
                    numberOrder: '',
                    statePathDriver: 'false',
                    comments: '',
                    inversion: false,
                    force_end_drive: false
                },
            }
        },
        updated() {
            this.newWorkunit.jobsiteId = this.jobsiteSelected;
            this.$emit('newWorkunit', this.newWorkunit)
            this.$emit('eventUpdateInfo', function () {this.listJobsite(); this.newWorkunit.jobsiteId = this.jobsiteSelected;})
        },
        created() {
            this.listJobsite()
        },
        methods: {
            deleteDropFile(index) {
                this.newWorkunit.pathKMZ.splice(index, 1)
            },
            listJobsite() {
                this.axios
                    .get('/jobsite/getJobsitesSelect')
                    .then(response => {
                        const genericResponse = response.data;
                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                            return;
                        }

                        this.jobsite = genericResponse.result;

                    })
                    .catch(error => {
                        this.$buefy.notification.open({
                            message: `Error: ${error.message}.`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                    })
            },
            loadWorkUnitsByJobSite() {
                this.jobsiteSelected = this.newWorkunit.jobsiteId;

                if (!this.isEdit)
                    return;

                try {
                    
                    this.newWorkunit = {};
                    this.newWorkunit.jobsiteId = this.jobsiteSelected;

                    this.isBusy = true;
                    this.axios
                        .get(`/workunit/jobsite/${this.newWorkunit.jobsiteId.id}`)
                        .then(response => {
                            const genericResponse = response.data;
                            if (genericResponse.isError) {
                                this.$buefy.notification.open({
                                    message: `Error: ${genericResponse.messageError}`,
                                    position: 'is-bottom-right',
                                    type: 'is-danger',
                                    hasIcon: true,
                                })
                                this.isBusy = false;
                                return;
                            }
                            this.isBusy = false;
                            this.workunits = genericResponse.result;

                        })
                        .catch(error => {
                            this.isBusy = false;
                            this.$buefy.notification.open({
                                message: `Error: ${error.message}.`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                        })
                } catch (e) {
                    this.isBusy = false;
                    this.$buefy.notification.open({
                        message: `Error: ${e.message}.`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true,
                    })
                }
            }
        },
        mounted() {
            this.$emit('newWorkunit', this.newWorkunit)
        },
    }
</script>
<style lang="scss">

    .map {
        height: 70vh;
        border-radius: 6px;
        z-index: 5;
    }
    .original-name{
        text-align: center;
        margin-bottom: 30px;
    }
</style>